// GENERATED FILE - DO NOT MODIFY

export enum GetFoodItemsSortColumnDto {
    Order = "Order",
    Name = "Name",
    CategoryName = "CategoryName",
}